import { Controller } from "stimulus";
import $ from "jquery";

export default class extends Controller {
  static targets = ["modal", "fileInput", "zone", "fileName", "confirmBtn"];

  open(event) {
    event.preventDefault();
    event.stopPropagation();
    this.currentInputId = event.currentTarget.dataset.inputId;
    this.fileInputTarget.value = "";
    this.fileNameTarget.classList.add("d-none");
    this.confirmBtnTarget.disabled = true;
    $(this.modalTarget).modal("show");
  }

  close() {
    $(this.modalTarget).modal("hide");
  }

  triggerFileInput(event) {
    event.preventDefault();
    this.fileInputTarget.click();
  }

  fileSelected() {
    const file = this.fileInputTarget.files[0];
    if (file) {
      this.fileNameTarget.textContent = file.name;
      this.fileNameTarget.classList.remove("d-none");
      this.confirmBtnTarget.disabled = false;
    }
  }

  dragover(event) {
    event.preventDefault();
    this.zoneTarget.classList.add("upload-zone--active");
  }

  dragleave() {
    this.zoneTarget.classList.remove("upload-zone--active");
  }

  drop(event) {
    event.preventDefault();
    this.zoneTarget.classList.remove("upload-zone--active");
    const file = event.dataTransfer.files[0];
    if (file) {
      const dt = new DataTransfer();
      dt.items.add(file);
      this.fileInputTarget.files = dt.files;
      this.fileNameTarget.textContent = file.name;
      this.fileNameTarget.classList.remove("d-none");
      this.confirmBtnTarget.disabled = false;
    }
  }

  confirm() {
    const file = this.fileInputTarget.files[0];
    if (!file) return;

    const targetInput = document.getElementById(this.currentInputId);
    if (!targetInput) return;

    const dt = new DataTransfer();
    dt.items.add(file);
    targetInput.files = dt.files;
    targetInput.closest("form").submit();
    this.close();
  }
}
